import { mapActions, mapGetters } from "vuex";
import { dynamicHead } from "../../../mixins/dynamic-head";

export default {
    name: "page-not-found",
    mixins: [dynamicHead],
    head: function() {
        return {
            title: () => {
                return {
                    inner: "Точка ",
                    separator: "|",
                    complement: "404 - Page Not Found",
                };
            },
            meta: () => {
                let meta = [
                    { n: "prerender-status-code", c: "404" },
                    { n: "robots", c: "noindex, nofollow" },
                ];
                return meta;
            },
        };
    },
    data() {
        return {};
    },
    components: {},
    computed: {
        ...mapGetters({
            allPagesList: "setting/allPagesList",
        }),
    },
    created() {
        this.getAllPages();
    },
    methods: {
        ...mapActions({
            getAllPages: "setting/GET_ALL_PAGES",
        }),
    },
};
